import React from 'react';
import styles from './AdminMobileMachList.module.css';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import AdminMobileEmptyMsg from './common/AdminMobileEmptyMsg';
import AdminMobileContentBox from './common/AdminMobileContentBox';
import { mainBgColor, mainPadd2, pageCommonGap1, pageEH3FontSize, registerGap1, registerGap2 } from '../constraints/AdminConst';
import P from 'components/P';
import liquidCigarImg from 'routes/adminMobile/images/liquidCigerImg.png';

const AdminMobileMachList = ({machines}) => {
    if (!machines || machines.length === 0) {
        return (
            <VerticalFlex>
                <FlexChild padding={mainPadd2}>
                    <AdminMobileEmptyMsg />
                </FlexChild>
            </VerticalFlex>
        );
    }

    return (
        <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={mainPadd2}>
            {machines && machines.map((machine, index) => (
                <FlexChild key={index} height="initial">
                    <AdminMobileContentBox flexStart>
                        <VerticalFlex gap={registerGap2}>
                            <FlexChild>
                                <div className={styles.borderBottom}>
                                    <HorizontalFlex gap={registerGap1}>
                                        <FlexChild width="auto">
                                            <img className={styles.liquid} src={liquidCigarImg} alt='액상담배 이미지' />
                                        </FlexChild>
                                        <FlexChild>
                                            <VerticalFlex gap={registerGap2}>
                                                <FlexChild alignItems="flex-start">
                                                    <P size={pageEH3FontSize}>
                                                        {machine.machineAffiliation} {machine.machineName}
                                                    </P>
                                                </FlexChild>
                                                <FlexChild>
                                                    <HorizontalFlex>
                                                        <FlexChild>
                                                            <P size={pageEH3FontSize}>
                                                                재고비율 {machine.machineInventoryRatio} %
                                                            </P>
                                                        </FlexChild>
                                                        {machine.machineWork === 'online' && (
                                                            <FlexChild justifyContent="flex-end">
                                                                <div className={styles.success}></div>
                                                                <P size={pageEH3FontSize} padding="0 0 0 0.5rem">
                                                                    정상
                                                                </P>
                                                            </FlexChild>
                                                        )}
                                                        {machine.machineWork === 'offline' && (
                                                            <FlexChild justifyContent="flex-end">
                                                                <div className={styles.offline}></div>
                                                                <P size={pageEH3FontSize} padding="0 0 0 0.5rem">
                                                                    오프라인
                                                                </P>
                                                            </FlexChild>
                                                        )}
                                                        {machine.machineWork === 'error' && (
                                                            <FlexChild justifyContent="flex-end">
                                                                <div className={styles.error}></div>
                                                                <P size={pageEH3FontSize} padding="0 0 0 0.5rem">
                                                                    오류
                                                                </P>
                                                            </FlexChild>
                                                        )}
                                                        {!machine.machineWork && (
                                                            <FlexChild justifyContent="flex-end">
                                                                <div className={styles.offline}></div>
                                                                <P size={pageEH3FontSize} padding="0 0 0 0.5rem">
                                                                    상태 없음
                                                                </P>
                                                            </FlexChild>
                                                        )}
                                                    </HorizontalFlex>
                                                </FlexChild>
                                            </VerticalFlex>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </div>
                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex gap={registerGap2}>
                                    <FlexChild>
                                        <HorizontalFlex>
                                            <FlexChild>
                                                <P size={pageEH3FontSize}>총매출</P>
                                            </FlexChild>
                                            <FlexChild justifyContent="flex-end">
                                                <P size={pageEH3FontSize}>
                                                    {machine.machineTotalSales ? machine.machineTotalSales.toLocaleString() : 0}
                                                </P>
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </FlexChild>
                                    <FlexChild>
                                        <HorizontalFlex>
                                            <FlexChild>
                                                <P size={pageEH3FontSize}>판매한 물건</P>
                                            </FlexChild>
                                            <FlexChild justifyContent="flex-end">
                                                <P size={pageEH3FontSize}>
                                                    {machine.machineSaleProductsCnt ? machine.machineSaleProductsCnt.toLocaleString() : 0} 개
                                                </P>
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </AdminMobileContentBox>
                </FlexChild>
            ))}
        </VerticalFlex>
    );
};

export default AdminMobileMachList;